<template>
  <base-modal hide-header hide-footer size="lg">
    <div class="col-12">
      <h3 class="editor-header">{{ $t('velho_equipment.add_new') }}</h3>
    </div>
    <div class="col-sm-12 nopads">
      <div class="col-sm-12 editor-form">
        <div class="col-sm-12 nopads pl-1 pr-1">
          <span class="span-title">{{ $t('velho_equipment.select_equipment_type') }}</span>
            <select
                v-model="selectedEquipment"
                class="form-select form-select-sm"
                :disabled="loading"
            >
                <option value="null" disabled>
                    {{ $t('velho_equipment.select_equipment_type') }}
                </option>
                <option
                    v-for="option in velhoEquipmentsSelectors"
                    :key="option.value"
                    :value="option.value"
                >
                    {{ option.text }}
                </option>
            </select>
        </div>
        <hr>
        <div class="col-sm-12">
          <Transition name="fade">
            <div>
              <culvert-editor
                v-if="selectedEquipment === EXTERNAL_CULVERTS"
                ref="velhoEquipmentEditor"
                style="pointer-events: all"
                :add-equipment-editor="true"
                :item="equipment"
              />
              <drain-editor
                v-if="selectedEquipment === EXTERNAL_DRAINS"
                ref="velhoEquipmentEditor"
                style="pointer-events: all"
                :add-equipment-editor="true"
                :item="equipment"
              />
              <portal-editor
                v-if="selectedEquipment === EXTERNAL_PORTALS"
                ref="velhoEquipmentEditor"
                style="pointer-events: all"
                :add-equipment-editor="true"
                :item="equipment"
              />
              <gate-editor
                v-if="selectedEquipment === EXTERNAL_GATES"
                ref="velhoEquipmentEditor"
                style="pointer-events: all"
                :add-equipment-editor="true"
                :item="equipment"
              />
              <roadside-advertisement-editor
                v-if="selectedEquipment === EXTERNAL_ROADSIDE_ADVERTISEMENTS"
                ref="velhoEquipmentEditor"
                style="pointer-events: all"
                :add-equipment-editor="true"
                :item="equipment"
              />
              <post-editor
                v-if="selectedEquipment === EXTERNAL_POSTS"
                ref="velhoEquipmentEditor"
                style="pointer-events: all"
                :add-equipment-editor="true"
                :item="equipment"
              />
              <stair-editor
                v-if="selectedEquipment === EXTERNAL_STAIRS"
                ref="velhoEquipmentEditor"
                style="pointer-events: all"
                :add-equipment-editor="true"
                :item="equipment"
              />
              <roadside-furniture-editor
                v-if="selectedEquipment === EXTERNAL_ROADSIDE_FURNITURE"
                ref="velhoEquipmentEditor"
                style="pointer-events: all"
                :add-equipment-editor="true"
                :item="equipment"
              />
              <railing-editor
                v-if="selectedEquipment === EXTERNAL_RAILINGS"
                ref="velhoEquipmentEditor"
                style="pointer-events: all"
                :add-equipment-editor="true"
                :item="equipment"
              />
              <booms-barriers-bollards-editor
                v-if="selectedEquipment === EXTERNAL_BOOMS_BARRIERS_AND_BOLLARDS"
                ref="velhoEquipmentEditor"
                style="pointer-events: all"
                :add-equipment-editor="true"
                :item="equipment"
              />
              <fence-editor
                v-if="selectedEquipment === EXTERNAL_FENCES"
                ref="velhoEquipmentEditor"
                style="pointer-events: all"
                :add-equipment-editor="true"
                :item="equipment"
              />
              <edge-support-editor
                v-if="selectedEquipment === EXTERNAL_EDGE_SUPPORTS"
                ref="velhoEquipmentEditor"
                style="pointer-events: all"
                :add-equipment-editor="true"
                :item="equipment"
              />
              <edge-pile-editor
                v-if="selectedEquipment === EXTERNAL_EDGE_PILES"
                ref="velhoEquipmentEditor"
                style="pointer-events: all"
                :add-equipment-editor="true"
                :item="equipment"
              />
              <lighting-editor
                v-if="selectedEquipment === EXTERNAL_LIGHTING"
                ref="velhoEquipmentEditor"
                style="pointer-events: all"
                :add-equipment-editor="true"
                :item="equipment"
              />
              <pipes-wires-cables-editor
                v-if="selectedEquipment === EXTERNAL_PIPES_WIRES_AND_CABLES"
                ref="velhoEquipmentEditor"
                style="pointer-events: all"
                :add-equipment-editor="true"
                :item="equipment"
              />
              <road-sign-editor
                v-if="selectedEquipment === EXTERNAL_TRAFFIC_SIGNS && equipment"
                ref="velhoEquipmentEditor"
                style="pointer-events: all"
                :add-equipment-editor="true"
                :item="equipment"
              />
            </div>
          </Transition>
        </div>
        <div class="col-sm-12 button-container pt-4 pb-0 mb-0">
          <button
            class="btn btn-secondary form-button"
            @click.stop="$emit('close')"
          >
            {{ $t('common.cancel') }}
          </button>
          <button
            class="btn btn-success form-button"
            :disabled="loading || selectedEquipment === null || !isEquipmentFormValid"
            @click.stop="submit"
          >
            {{ $t('common.save') }}
          </button>
        </div>
      </div>
    </div>
    <div
      v-if="loading > 0"
      id="loader"
      class="spinner"
    />
  </base-modal>
</template>

<script>
import BaseModal from '@/components/BaseModal'
import {mapHelper} from "@/components/mixins/MapMixin";
import {restApi} from '@/components/mixins/RestApiMixin'
import CulvertEditor from "@/components/velho/CulvertEditor";
import DrainEditor from "@/components/velho/DrainEditor";
import PortalEditor from "@/components/velho/PortalEditor";
import GateEditor from "@/components/velho/GateEditor";
import RoadsideAdvertisementEditor from "@/components/velho/RoadsideAdvertisementEditor";
import PostEditor from "@/components/velho/PostEditor";
import StairEditor from "@/components/velho/StairEditor";
import RoadsideFurnitureEditor from "@/components/velho/RoadsideFurnitureEditor";
import RailingEditor from "@/components/velho/RailingEditor";
import BoomsBarriersBollardsEditor from "@/components/velho/BoomsBarriersBollardsEditor";
import FenceEditor from "@/components/velho/FenceEditor";
import EdgeSupportEditor from "@/components/velho/EdgeSupportEditor";
import EdgePileEditor from "@/components/velho/EdgePileEditor";
import LightingEditor from "@/components/velho/LightingEditor";
import PipesWiresCablesEditor from "@/components/velho/PipesWiresCablesEditor";
import RoadSignEditor from "@/components/velho/RoadSignEditor";
import VelhoRoadSignModel from "@/models/integrations/velho/RoadSignModel";
import VelhoCulvertModel from "@/models/integrations/velho/CulvertModel";
import VelhoDrainModel from "@/models/integrations/velho/DrainModel";
import VelhoPortalModel from "@/models/integrations/velho/PortalModel";
import VelhoGateModel from "@/models/integrations/velho/GateModel";
import VelhoRoadsideAdvertisementModel from "@/models/integrations/velho/RoadsideAdvertisementModel";
import VelhoPostModel from "@/models/integrations/velho/PostModel";
import VelhoStairsModel from "@/models/integrations/velho/StairsModel";
import VelhoRoadsideFurnitureModel from "@/models/integrations/velho/RoadsideFurnitureModel";
import VelhoBoomsBarriersBollardsModel from "@/models/integrations/velho/BoomsBarriersBollardsModel";
import VelhoFenceModel from "@/models/integrations/velho/FenceModel";
import VelhoPipesWiresCablesModel from "@/models/integrations/velho/PipesWiresCablesModel";
import VelhoEdgePileMode from "@/models/integrations/velho/EdgePileMode";
import VelhoEdgeSupportsModel from "@/models/integrations/velho/EdgeSupportsModel";
import VelhoRailingModel from "@/models/integrations/velho/RailingModel";
import VelhoLightingModel from "@/models/integrations/velho/LightingModel";
import {inject} from "vue";

export default {
    name: 'VelhoEquipmentWizard',
    components: {
        BaseModal,
        CulvertEditor,
        DrainEditor,
        PortalEditor,
        GateEditor,
        RoadsideAdvertisementEditor,
        PostEditor,
        StairEditor,
        RoadsideFurnitureEditor,
        RailingEditor,
        BoomsBarriersBollardsEditor,
        FenceEditor,
        EdgeSupportEditor,
        EdgePileEditor,
        LightingEditor,
        PipesWiresCablesEditor,
        RoadSignEditor
    },
    mixins: [mapHelper, restApi],
    props: {
        coordinate: {
            type: Object
        },
        selectedContract: {
            type: Object,
            default: null
        },
    },
    data: function () {
        return {
            loading: false,
            roadData: {
                roadNum: null,
                roadSec: null,
                distance: null
            },
            velhoCoordinate: this.coordinate,
            selectedEquipment: null,
            equipment: null,
            isEquipmentFormValid: false
        }
    },
    computed: {
        velhoEquipmentsSelectors() {
            return [
                {
                    text: this.$t("external_road_signs.road_signs"),
                    value: this.EXTERNAL_TRAFFIC_SIGNS
                },
                {
                    text: this.$t("infra.posts"),
                    value: this.EXTERNAL_POSTS
                },
                {
                    text: this.$t("culvert.title"),
                    value: this.EXTERNAL_CULVERTS,
                },
                {
                    text: this.$t("railing.title"),
                    value: this.EXTERNAL_RAILINGS,
                },
                {
                    text: this.$t("portal.title"),
                    value: this.EXTERNAL_PORTALS,
                },
                {
                    text: this.$t("drain.title"),
                    value: this.EXTERNAL_DRAINS,
                },
                {
                    text: this.$t("fence.title"),
                    value: this.EXTERNAL_FENCES,
                },
                {
                    text: this.$t("stair.title"),
                    value: this.EXTERNAL_STAIRS,
                },
                {
                    text: this.$t("gate.title"),
                    value: this.EXTERNAL_GATES,
                },
                {
                    text: this.$t("edge_support.title"),
                    value: this.EXTERNAL_EDGE_SUPPORTS,
                },
                {
                    text: this.$t("edge_pile.title"),
                    value: this.EXTERNAL_EDGE_PILES,
                },
                {
                    text: this.$t("roadside_furniture.title"),
                    value: this.EXTERNAL_ROADSIDE_FURNITURE,
                },
                {
                    text: this.$t("roadside_advertisement.title"),
                    value: this.EXTERNAL_ROADSIDE_ADVERTISEMENTS,
                },
                {
                    text: this.$t("boom_barrier_bollard.title"),
                    value: this.EXTERNAL_BOOMS_BARRIERS_AND_BOLLARDS,
                },
                {
                    text: this.$t("pipe_wire_cable.title"),
                    value: this.EXTERNAL_PIPES_WIRES_AND_CABLES,
                },
                {
                    text: this.$t("lighting.title"),
                    value: this.EXTERNAL_LIGHTING,
                }
            ]
        }
    },
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert')
        return { showAlert }
    },
    watch: {
        selectedEquipment(equipmentId) {
            const coordinates = {
                y: this.velhoCoordinate.lat,
                x: this.velhoCoordinate.lng
            }
            // Initialize equipment model
            switch (equipmentId) {
                case this.EXTERNAL_CULVERTS:
                    this.equipment = VelhoCulvertModel.instanceWithPosition(coordinates, this.roadData.roadNum, this.roadData.roadSec, this.roadData.distance)
                    break;
                case this.EXTERNAL_DRAINS:
                this.equipment = VelhoDrainModel.instanceWithPosition(coordinates, this.roadData.roadNum, this.roadData.roadSec, this.roadData.distance)
                    break;
                case this.EXTERNAL_PORTALS:
                    this.equipment = VelhoPortalModel.instanceWithPosition(coordinates, this.roadData.roadNum, this.roadData.roadSec, this.roadData.distance)
                    break;
                case this.EXTERNAL_GATES:
                    this.equipment = VelhoGateModel.instanceWithPosition(coordinates, this.roadData.roadNum, this.roadData.roadSec, this.roadData.distance)
                    break;
                case this.EXTERNAL_ROADSIDE_ADVERTISEMENTS:
                    this.equipment = VelhoRoadsideAdvertisementModel.instanceWithPosition(coordinates, this.roadData.roadNum, this.roadData.roadSec, this.roadData.distance)
                    break;
                case this.EXTERNAL_POSTS:
                    this.equipment = VelhoPostModel.instanceWithPosition(coordinates, this.roadData.roadNum, this.roadData.roadSec, this.roadData.distance)
                    break;
                case this.EXTERNAL_STAIRS:
                    this.equipment = VelhoStairsModel.instanceWithPosition(coordinates, this.roadData.roadNum, this.roadData.roadSec, this.roadData.distance)
                    break;
                case this.EXTERNAL_ROADSIDE_FURNITURE:
                    this.equipment = VelhoRoadsideFurnitureModel.instanceWithPosition(coordinates, this.roadData.roadNum, this.roadData.roadSec, this.roadData.distance)
                    break;
                case this.EXTERNAL_BOOMS_BARRIERS_AND_BOLLARDS:
                    this.equipment = VelhoBoomsBarriersBollardsModel.instanceWithPosition(coordinates, this.roadData.roadNum, this.roadData.roadSec, this.roadData.distance)
                    break;
                case this.EXTERNAL_FENCES:
                    this.equipment = VelhoFenceModel.instanceWithPosition(coordinates, this.roadData.roadNum, this.roadData.roadSec, this.roadData.distance)
                    break;
                case this.EXTERNAL_EDGE_SUPPORTS:
                    this.equipment = VelhoEdgeSupportsModel.instanceWithPosition(coordinates, this.roadData.roadNum, this.roadData.roadSec, this.roadData.distance)
                    break;
                case this.EXTERNAL_LIGHTING:
                    this.equipment = VelhoLightingModel.instanceWithPosition(coordinates, this.roadData.roadNum, this.roadData.roadSec, this.roadData.distance)
                    break;
                case this.EXTERNAL_PIPES_WIRES_AND_CABLES:
                    this.equipment = VelhoPipesWiresCablesModel.instanceWithPosition(coordinates, this.roadData.roadNum, this.roadData.roadSec, this.roadData.distance)
                    break;
                case this.EXTERNAL_TRAFFIC_SIGNS:
                    this.equipment = VelhoRoadSignModel.instanceWithPosition(coordinates, this.roadData.roadNum, this.roadData.roadSec, this.roadData.distance)
                    break;
                 case this.EXTERNAL_EDGE_PILES:
                    this.equipment = VelhoEdgePileMode.instanceWithPosition(coordinates, this.roadData.roadNum, this.roadData.roadSec, this.roadData.distance)
                    break;
                 case this.EXTERNAL_RAILINGS:
                    this.equipment = VelhoRailingModel.instanceWithPosition(coordinates, this.roadData.roadNum, this.roadData.roadSec, this.roadData.distance)
                    break;
                default:
                    break;
            }
        },
        'equipment': {
            handler() {
                this.$nextTick(() => {
                    if(!this.$refs.velhoEquipmentEditor) { return this.isEquipmentFormValid = false }
                    if(!this.$refs.velhoEquipmentEditor.isValidForm) { return this.isEquipmentFormValid = false }
                    this.isEquipmentFormValid = this.$refs.velhoEquipmentEditor.isValidForm()
                });
            },
            deep: true
        }
    },
    mounted() {
        this.fetchRoadDataByCoordinates(this.velhoCoordinate)
    },
    methods: {
        fetchRoadDataByCoordinates(coord) {
            try {
                this.loading = true
                this.restFetchParams(this.coordinateFrameConverter, {lat: coord.lat, lon: coord.lng}, (response) => {
                    this.loading = false
                    if(response.data) {
                        this.roadData = {
                            roadNum: response.data.roadNum,
                            roadSec: response.data.secNum,
                            distance: response.data.distanceSecStart
                        }
                    }
                }, () => { this.loading = false })
            } catch (error) {
                this.loading = false
            }
        },
        submit() {
            let data = {
                ...this.equipment.toJSON(),
                created_at: this.equipment.created_at || this.equipment.get && this.equipment.get('created_at'),
                contract: {
                    'id': this.selectedContract ? this.selectedContract.id : null,
                    'external_contract_id': this.selectedContract && this.selectedContract.external_contract ? this.selectedContract.external_contract.external_id : null
                }
            }

            this.loading = true
            try {
                this.restAdd(this.extEquipmentUrl, data, () => {
                    this.loading = false
                    this.showAlert(this.$t('common.alert_add_success'), 'success')
                    this.$nextTick(() => this.$emit('close'))
                }, () => {
                    this.loading = false
                    this.showAlert(this.$t('common.alert_add_failed'))
                })
            } catch (error) {
                this.showAlert(this.$t('common.alert_add_failed'))
                this.loading = false
            }
        }
    }
}
</script>
<style>
@import "../../styles/modal.css";

.modal-container {
    min-width: 70%;
}
</style>
